import React from "react";

import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ClientApplication } from "../msal/clientApp";
import LoginPage from "../pages/loginPage/loginPage";
import App from "./App";

export const RootContainer: React.FC = () => (
    <MsalProvider instance={ClientApplication.instance}>
        <AuthenticatedTemplate>
            <App />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={LoginPage} />

                    <Redirect to="/" />
                </Switch>
            </BrowserRouter>
        </UnauthenticatedTemplate>
    </MsalProvider>
)

